import moment from 'moment';
import config from 'config';
import {PAY_TYPE} from 'utils/const';
import Color from 'color';

export const toUrl = function(url){
    window.location.href = config.basename + url;
};
export const getUrl = function(url){
    return config.basename + url;
};
export const getDocUrl = function(url){
    return config.docUrl + url;
};
//incluedToday true,今天与今天之后的为false
//incluedToday false,今天之后的为false,今天为true
export const disabledDateAfterNow = function(current,incluedToday=false){
    let compareMoment = moment();
    if(!incluedToday){
        compareMoment = moment().subtract(1, 'days');
    }
    if(current){
        return current.isAfter(compareMoment,'day');
    }
    return current;
};

export const disabledMonthAfterNow = function(current){
    const compareMoment = moment();
    if(current){
        return current.isAfter(compareMoment,'month');
    }
    return current;
};

export const comdify = function(n){
    n = n + '';
    const re=/\d{1,3}(?=(\d{3})+$)/g;
    const n1=n.replace(/^(\d+)((\.\d+)?)$/,function(s,s1,s2){return s1.replace(re,'$&,')+s2;});
    return n1;
};

export const payMethod = function(type,params) {
    switch (type) {
        case PAY_TYPE.OFFLINE:
            break;
        case PAY_TYPE.ALIPAY:
            window.open('https://mapi.alipay.com/gateway.do?'+params);
            break;
        case PAY_TYPE.PERSONAL:
        case PAY_TYPE.ENTERPRISE:
            postFormZhongjin(params);
            break;
        default:
            break;
    }
};
const postFormZhongjin = (params)=>{
    const f = document.createElement('form');
    f.method = 'post';
    f.action = config.zhongjinPayUrl;
    f.target = '_black';
    document.body.appendChild(f);
    Object.keys(params).forEach(item=>{
        const i = document.createElement('input');
        i.type = 'hidden';
        f.appendChild(i);
        i.value = params[item];
        i.name = item;
    });
    f.submit();
};


//获取拐点样式
export function getSeries(data,name,color){
    const _color = Color(color);
    return {
        data,
        name,
        type: 'line',
        lineStyle:{
            color:_color.string(),
            shadowBlur:6,
            shadowColor:'rgba(197,200,255,1)',
            shadowOffsetY:1
        },
        showAllSymbol:true,
        symbolSize:10,
        symbol:'circle',
        hoverAnimation:false,
        markPoint:{
            symbolSize:50
        },
        emphasis:{
            itemStyle:{
                borderColor:_color.alpha(0.5).string(),
                borderWidth:8
            }
        },
        itemStyle:{
            color:_color.string()
        }
    };
}

/**
 * 检测字符串为空或null或undefined
 */
export function checkNotEmpty(value){
    if(value === null || value ==='' || typeof value === 'undefined'){
        return false;
    }else{
        return true;
    }
}

/*** method **
 * 根据指定key，从object创建新object，指定key与object的key区交集,常用于表单回填
 * dic: 指定key对象
 * obj: 给定对象
 *
 */
export function mixObj(dic,obj) {
    const newValues = {};
    Object.keys(dic).forEach(item=>{
        if(typeof obj[item] !== 'undefined'){
            newValues[item] = obj[item];
        }
    });
    return newValues;
}


/*** method **
 * 根据指定key，从object创建新object，指定key与object的key区交集,只取不为‘’，null,undefined的值。
 * 仅在lite中使用
 * dic: 指定key对象
 * obj: 给定对象
 *
 */
export function mixObjNotEmpty(dic,obj) {
    const newValues = {};
    Object.keys(dic).forEach(item=>{
        if(typeof obj[item] !== 'undefined' && obj[item]!==null && obj[item]!==''){
            newValues[item] = obj[item];
        }
    });
    return newValues;
}



// WEBPACK FOOTER //
// ./src/utils/tool.js